import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="preguntas" className="w-full bg-cream" data-id="element-85" data-mp="1l9o8dd7a47nu">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-86" data-mp="1gdqowy0pyl6u">
        <div className="grid gap-10 lg:grid-cols-[20rem_1fr] lg:gap-20" data-id="element-87" data-mp="2e0zilgavj0jx">
          <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-88" data-mp="2dy3j3njdo3td">
            Lo que más nos preguntan
          </h2>

          <div className="divide-y divide-line border-y border-line" data-id="element-89" data-mp="2418ohfq86nkd">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} data-id="element-90" data-mp="smv3cimuwm81" data-mpi={index}>
                  <h3 data-id="element-91" data-mp="snwd8js4z2o6">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-92" data-mp="sl0favgagdzq">
                      <span className="font-display text-lg font-bold text-ink" data-id="element-93" data-mp="ugr52kq5qegv">
                        {faq.question}
                      </span>
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white text-forest" aria-hidden="true" data-id="element-94" data-mp="fj8inp0ycdcl">
                        {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-95" data-mp="6qwts7lhkxyq" /> : <PlusIcon className="h-4 w-4" data-id="element-96" data-mp="6qoigk50i0pn" />}
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-97" data-mp="bjzqupph2pjo">
                    {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-98" data-mp="3szziwkvxyqx9">
                        <p className="max-w-2xl pb-6 text-base leading-relaxed text-ink-muted" data-id="element-99" data-mp="1ppmbaurkcgar">
                          {faq.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}